module.exports = __webpack_public_path__ + "img/jcdt.1e56721d.svg";